import gql from 'graphql-tag'
import {apolloClient} from '../../libs/apollo'

export default {
    namespaced: true,
    state: {
        all: null,
    },
    getters: {},
    mutations: {
        setCollaborators(state, collaborators) {
            state.all = collaborators;
        },
        setFormCollaborator(state, collaborator) {
            state.formCollaborator = collaborator;
        },
    },
    actions: {
        async getAllCollaborators({commit/*, rootGetters*/}) {
            const result = await apolloClient.query({
                // Query
                query: gql`query {
                    people(filter: {}) {
                        id
                        name
                        email
                        phones
                        role{
                            id
                            name
                        }
                    }
                }`,
                // Parameters
                // variables: {
                //     companyId: rootGetters["auth/currentCompanyId"],
                // }
            });
            commit("setCollaborators", result.data.people);
        },
        async getCollaborator(_, collaboratorId) {
            const result = await apolloClient.query({
                // Query
                query: gql`query ($collaboratorId: ID!) {
                    person(filter: {id: $collaboratorId}) {
                        id
                        name
                        email
                        phones
                        taxNumber
                        note
                        birthDate
                        active
                        user{
                            id
                            username
                            banned
                        }
                        role {
                            id
                        }
                    }
                }`,
                // Parameters
                variables: {
                    collaboratorId: collaboratorId,
                }
            });
            return result.data.person;
        }
    }
}
